// extracted by mini-css-extract-plugin
export default {"chooseCard":"ChooseCard_chooseCard__lVhop","chooseCard__img":"ChooseCard_chooseCard__img__W9k-m","chooseCard__title":"ChooseCard_chooseCard__title__3zkDT"};